module.exports = __webpack_public_path__ + "img/rwm.331260cc.png";